__turbopack_context__.v({
  "inputWrapper": "HOEt-q_inputWrapper",
  "searchDropdown": "HOEt-q_searchDropdown",
  "searchIcon": "HOEt-q_searchIcon",
  "searchbox": "HOEt-q_searchbox",
  "searchboxMobile": "HOEt-q_searchboxMobile",
  "searchinput": "HOEt-q_searchinput",
});
